import { useTranslation } from 'next-i18next'

import ContactAvatar from '~/booking/components/ContactAvatar/ContactAvatar'
import ROUTES from '~/shared/constants/routes.const'
import { Link } from '~/components/Link'
import todAnalytics from '~/analytics/tod/todAnalytics'
import { TodButtonEventName } from '~/analytics/tod/todEvents.types'

export default function BookingHome(): React.ReactElement {
  const { t } = useTranslation(['booking', 'tutorOnDemand'])

  const handleBookingButtonClick = () => {
    todAnalytics.logButtonClick(TodButtonEventName.BOOKING_BUTTON, 'book now')
  }

  return (
    <section className="relative h-full px-3 lg:px-0">
      <div className="mb-16 xl:mb-0">
        <div className="mb-4 flex flex-col xl:flex-row items-center xl:items-start xl:w-fit xl:m-auto">
          <div className="mb-4 flex-1 m-auto xl:m-0 xl:max-w-lg">
            <header className="mb-5 text-white">
              <h1 className="mb-2 text-h3 font-medium">{t('booking:title')}</h1>
              <p className="whitespace-pre-line tracking-wide leading-7">{t('booking:description')}</p>
            </header>
            <div className="md:flex space-y-4 md:space-y-0 md:space-x-4">
              <TypeSelectButton
                onClick={handleBookingButtonClick}
                path={ROUTES.BOOKING_FOR_SELF}
                title={t('booking:bookingFor.long.self')}
              />
            </div>
          </div>
          <ContactAvatar />
        </div>
      </div>
      <p className="max-w-lg pt-8 text-xs xl:text-sm text-white md:absolute bottom-0 font-extralight">
        <i>{t('tutorOnDemand:landingPage.funFact')}</i>
      </p>
    </section>
  )
}

const TypeSelectButton = ({
  path,
  title,
  onClick,
}: {
  path: string
  title: string
  onClick: () => void
}): React.ReactElement => {
  return (
    <Link
      className="md:w-48 h-36 bg-transparent border-2 rounded text-white border-white leading-7 tracking-wide font-semibold px-8 md:px-9 text-sm text-center flex flex-col justify-center"
      onClick={onClick}
      to={path}
    >
      {title}
    </Link>
  )
}
